import api from './api';

export const pacienteMedicamentoService = {
  // Listar medicamentos vinculados a um paciente
  getByPaciente: async (pacienteId, incluirInativos = false) => {
    const response = await api.get(`/pacientes-medicamentos/paciente/${pacienteId}`, {
      params: { incluirInativos }
    });
    return response.data;
  },

  // Vincular medicamento ao paciente
  create: async (vinculacaoData) => {
    const response = await api.post('/pacientes-medicamentos', vinculacaoData);
    return response.data;
  },

  // Atualizar vinculação
  update: async (id, vinculacaoData) => {
    const response = await api.put(`/pacientes-medicamentos/${id}`, vinculacaoData);
    return response.data;
  },

  // Remover vinculação (soft delete)
  delete: async (id) => {
    const response = await api.delete(`/pacientes-medicamentos/${id}`);
    return response.data;
  },

  // Buscar medicamentos disponíveis para vincular
  getMedicamentosDisponiveis: async (search = '', categoria = '', pacienteId = '') => {
    const response = await api.get('/pacientes-medicamentos/medicamentos/disponiveis', {
      params: { search, categoria, pacienteId }
    });
    return response.data;
  },

  // Relatório de controle de estoque
  getRelatorioControleEstoque: async (categoria = '') => {
    const response = await api.get('/pacientes-medicamentos/relatorio/controle-estoque', {
      params: { categoria }
    });
    return response.data;
  },

  // Buscar histórico de modificações de um paciente
  getHistorico: async (pacienteId) => {
    const response = await api.get(`/pacientes-medicamentos/paciente/${pacienteId}/historico`);
    return response.data;
  }
};